import imageAndrewS from "../public/img/trainers/andrew_seffi.jpg";
import imageVeronikaH from "../public/img/trainers/veronika_huna.jpg";
import imageTomasS from "../public/img/trainers/tomas_strnad.jpg";
import imageAndreaK from "../public/img/trainers/andrea_kinska.jpg";
import imageKimS from "../public/img/trainers/kim_simunova.jpg";
import imageDavidP from "../public/img/trainers/david_partl.jpg";
import imageAndreaH from "../public/img/trainers/andrea_hlavickova.jpg";
import imageEvaD from "../public/img/trainers/eva_dobesova.jpg";
import imageJiriZ from "../public/img/trainers/jiri_zikmund.jpg";
import imageVeronikaB from "../public/img/trainers/veronika_benesova.jpg";
import imageKaterinaB from "../public/img/trainers/katerina_baudysova.jpg";
import imageLenkaH from "../public/img/trainers/lenka_havlicek.jpg";
import imageAlexZ from "../public/img/trainers/alex_zoubkova.jpg";
import imageMartinaD from "../public/img/trainers/martina_digrinova.jpg";
import imageMilanK from "../public/img/trainers/milan_konopasek.jpg";
import imageLukasS from "../public/img/trainers/lukas_svoboda.jpg";
import imageDenisaZ from "../public/img/trainers/denisa_zidekova.jpg";
import imageKrystofF from "../public/img/trainers/krystof_fila.jpg";
import imageNikolaS from "../public/img/trainers/nikola_simunkova.jpg";
import imageTerezaD from "../public/img/trainers/tereza_dobiasova.jpg";
import imageTerezaS from "../public/img/trainers/tereza_solarova.jpg";
import imageKaterinaT from "../public/img/trainers/katerina_tumova.jpg";
import imageMarcoP from "../public/img/trainers/marco_pier.jpg";
import imageNikolaB from "../public/img/trainers/nikola_brizova.jpg";
import imagePetraP from "../public/img/trainers/petra_pilna.jpg";
import imageKamilaP from "../public/img/trainers/kamila_pavlickova.jpg";
import imageViktorieCh from "../public/img/trainers/viktorie_chovancova.jpg";
import imageImmanuelA from "../public/img/trainers/immanuel_adenaubi.jpg";
import imageBarboraS from "../public/img/trainers/barbora_szarkova.jpg";
import imageBarboraM from "../public/img/trainers/barbora_millerova.jpg";
import imageNikolaM from "../public/img/trainers/nikola_mandikova.jpg";
import imageMartinaV from "../public/img/trainers/martina_vaic.jpg";
import imageMichaelaF from "../public/img/trainers/michaela_francova.jpg";
import imageEvaK from "../public/img/trainers/eva_karska.jpg";
import imageJakubF from "../public/img/trainers/jakub_filipec.jpg";
import imagePavlinaB from "../public/img/trainers/pavlina_baudysova.jpg";
import imagePiperP from "../public/img/trainers/piper_parker.jpg";
import imagePollyD from "../public/img/trainers/polly_dvorkin.jpg";
import imageMarekR from "../public/img/trainers/marek_rakus.jpg";
import imagePetrM from "../public/img/trainers/petr_miskovsky.jpg";
import imageKristynaK from "../public/img/trainers/kristyna_kajgrova.jpg";
import imageZofieP from "../public/img/trainers/zofie_pickova.jpg";
import imageOndrejB from "../public/img/trainers/ondrej_becan.jpg";
import imageAncelF from "../public/img/trainers/ancel_fermont.jpg";
import imageBarboraP from "../public/img/trainers/barbora_poulova.jpg";
import imageBeccaH from "../public/img/trainers/becca_horak.jpg";
import imageKatD from "../public/img/trainers/kat_dymakova.jpg";
import imageLukasB from "../public/img/trainers/lukas_beranek.jpg";
import imageMartinaK from "../public/img/trainers/martina_kosikova.jpg";
import imageMilanKotrba from "../public/img/trainers/milan_kotrba.jpg";
import imageNatalieH from "../public/img/trainers/natalie_hajna.jpg";
import imagePetraK from "../public/img/trainers/petra_kacirkova.jpg";
import imageSarkaS from "../public/img/trainers/sarka_sachl.jpg";


import imageMartinM from "../public/img/trainers/martin_molcik.jpg";
import imageZbynekV from "../public/img/trainers/zbynek_vlcek.jpg";
import imageViktorieF from "../public/img/trainers/viktorie_filipi.jpg";
import imageLenkaD from "../public/img/trainers/lenka_dewachter.jpg";
import imageTatianaH from "../public/img/trainers/tatiana_hatadamova.jpg";
import imageKathiS from "../public/img/trainers/kathi_siebenhandl.jpg";
import imageRomanaZ from "../public/img/trainers/romana_zikmundova.jpg";
import imageMichaelaM from "../public/img/trainers/michaela_mackovicova.jpg";
import imageMartinaDeverova from "../public/img/trainers/martina_deverova.jpg";
import imagePetrR from "../public/img/trainers/petr_rada.jpg";
import imageSabinaA from "../public/img/trainers/sabina_azizova.jpg";
import imageMonikaZ from "../public/img/trainers/monika_zemankova.jpg";
import imageTerezaE from "../public/img/trainers/tereza_eliasova.jpg";



export const getTrainers = (trainers, activeFilters, branchLocation) => {
    const { gender, concept, location } = activeFilters;

    if (!gender && !concept && !location && !branchLocation) {
        return trainers;
    }

    return trainers.filter(trainer => {
        if (branchLocation) {
            return trainer.locations.includes(branchLocation);
        }

        let show = true;

        if (gender) {
            show = gender === trainer.gender;
        }
        if (concept) {
            show = show && trainer.concepts.includes(concept);
        }
        if (location) {
            show = show && trainer.locations.includes(location);
        }

        return show;
    });
};

export const trainersList = [
    // ########
    // TRAINERS
    // ########
    {
        "name": "Ancel F.",
        "instagram": "ancelfermont",
        "cleanName": "Ancel Fermont",
        "gender": "FEMALE",
        "concepts": [
            "PERSONAL_TRAINER",
            "NEXT_BATTLE",
            "NEXT_BOOST"
        ],
        "locations": [
            "KARLIN",
            "SMICHOV"
        ],
        "image": imageAncelF
    },
    {
        "name": "Andrew S.",
        "instagram": "andrew_seffi",
        "cleanName": "Andrew Seffi",
        "gender": "MALE",
        "concepts": [
            "PERSONAL_TRAINER"
        ],
        "locations": [
            "KARLIN",
            "HOLESOVICE"
        ],
        "image": imageAndrewS
    },
    {
        "name": "Alex Z.",
        "instagram": "alexis.ewart",
        "cleanName": "Alex Zoubkova",
        "gender": "FEMALE",
        "concepts": [
            "PERSONAL_TRAINER"
        ],
        "locations": [
            "KARLIN",
            "SMICHOV"
        ],
        "image": imageAlexZ
    },
    {
        "name": "David P.",
        "instagram": "davidakcz",
        "cleanName": "David Partl",
        "gender": "MALE",
        "concepts": [
            "PERSONAL_TRAINER",
            "NEXT_BATTLE",
            "LES_MILLS"
        ],
        "locations": [
            "KARLIN"
        ],
        "image": imageDavidP
    },
    {
        "name": "Immanuel A.",
        "instagram": "immanueladenubi",
        "cleanName": "Immanuel Adenaubi",
        "gender": "MALE",
        "concepts": [
            "PERSONAL_TRAINER"
        ],
        "locations": [
            "KARLIN",
            "VINOHRADY"
        ],
        "image": imageImmanuelA
    },
    {
        "name": "Kamila P.",
        "instagram": "kamila_pavlickova",
        "cleanName": "Kamila Pavlickova",
        "gender": "FEMALE",
        "concepts": [
            "PERSONAL_TRAINER"
        ],
        "locations": [
            "VINOHRADY",
            "SMICHOV"
        ],
        "image": imageKamilaP
    },
    {
        "name": "Kateřina B.",
        "instagram": "katyb_workouts",
        "cleanName": "Katerina Baudysova",
        "gender": "FEMALE",
        "concepts": [
            "PERSONAL_TRAINER",
            "NEXT_BURN",
            "NEXT_BATTLE",
            "NEXT_BOOST"
        ],
        "locations": [
            "KARLIN",
            "HOLESOVICE"
        ],
        "image": imageKaterinaB
    },
    {
        "name": "Kateřina T.",
        "instagram": "katerinatumova.pt",
        "cleanName": "Katerina Tumova",
        "gender": "FEMALE",
        "concepts": [
            "PERSONAL_TRAINER"
        ],
        "locations": [
            "KARLIN",
            "HOLESOVICE"
        ],
        "image": imageKaterinaT
    },
    {
        "name": "Kim Š.",
        "instagram": "kimsimunova",
        "cleanName": "Kim Simunova",
        "gender": "FEMALE",
        "concepts": [
            "PERSONAL_TRAINER",
            "NEXT_BOOTY",
        ],
        "locations": [
            "KARLIN",
            "VINOHRADY"
        ],
        "image": imageKimS
    },
    {
        "name": "Kryštof F.",
        "instagram": "krystoffila",
        "cleanName": "Krystof Fila",
        "gender": "MALE",
        "concepts": [
            "PERSONAL_TRAINER"
        ],
        "locations": [
            "KARLIN",
            "HOLESOVICE",
            "VINOHRADY",
            "SMICHOV",
        ],
        "image": imageKrystofF
    },
    {
        "name": "Lenka H.",
        "instagram": "lenka.havlicek.healthcoach",
        "cleanName": "Lenka Havlicek",
        "gender": "FEMALE",
        "concepts": [
            "PERSONAL_TRAINER",
            "NEXT_YOGA"
        ],
        "locations": [
            "KARLIN"
        ],
        "image": imageLenkaH
    },
    {
        "name": "Lukáš S.",
        "instagram": "svobodalukas_",
        "cleanName": "Lukas Svoboda",
        "gender": "MALE",
        "concepts": [
            "PERSONAL_TRAINER"
        ],
        "locations": [
            "HOLESOVICE",
            "VINOHRADY",
            "SMICHOV"
        ],
        "image": imageLukasS
    },
    {
        "name": "Marco P.",
        "instagram": "marco.pierr",
        "cleanName": "Marco Pier",
        "gender": "MALE",
        "concepts": [
            "PERSONAL_TRAINER",
            "NEXT_BOOST"
        ],
        "locations": [
            "KARLIN",
            "HOLESOVICE",
            "VINOHRADY",
            "SMICHOV"
        ],
        "image": imageMarcoP
    },
    {
        "name": "Martin M.",
        "instagram": "martin.molcik",
        "cleanName": "Martin Molcik",
        "gender": "MALE",
        "concepts": [
            "PERSONAL_TRAINER"
        ],
        "locations": [
            "KARLIN",
            "HOLESOVICE"
        ],
        "image": imageMartinM
    },
    {
        "name": "Martina D.",
        "instagram": "digrinec",
        "cleanName": "Martina Digrinova",
        "gender": "FEMALE",
        "concepts": [
            "PERSONAL_TRAINER",
            "NEXT_BOOTY",
            "LES_MILLS",
        ],
        "locations": [
            "KARLIN",
            "VINOHRADY",
            "SMICHOV"
        ],
        "image": imageMartinaD
    },
    {
        "name": "Milan K.",
        "instagram": "milan_konopasek",
        "cleanName": "Milan Konopasek",
        "gender": "MALE",
        "concepts": [
            "PERSONAL_TRAINER",
            "NEXT_BURN"
        ],
        "locations": [
            "KARLIN",
            "HOLESOVICE"
        ],
        "image": imageMilanK
    },
    {
        "name": "Milan K.",
        "instagram": "milan_kotrba",
        "cleanName": "Milan Kotrba",
        "gender": "MALE",
        "concepts": [
            "PERSONAL_TRAINER"
        ],
        "locations": [
            "KARLIN",
            "SMICHOV"
        ],
        "image": imageMilanKotrba
    },
    {
        "name": "Nikola B.",
        "instagram": "nicimendez",
        "cleanName": "Nikola Brizova",
        "gender": "FEMALE",
        "concepts": [
            "PERSONAL_TRAINER",
        ],
        "locations": [
            "KARLIN",
            "SMICHOV"
        ],
        "image": imageNikolaB
    },
    {
        "name": "Petra P.",
        "instagram": "pilnas",
        "cleanName": "Petra Pilna",
        "gender": "FEMALE",
        "concepts": [
            "PERSONAL_TRAINER"
        ],
        "locations": [
            "KARLIN",
            "HOLESOVICE",
            "SMICHOV"
        ],
        "image": imagePetraP
    },
    {
        "name": "Terka S.",
        "instagram": "tessa_s1",
        "cleanName": "Tereza Solarova",
        "gender": "FEMALE",
        "concepts": [
            "PERSONAL_TRAINER",
            "NEXT_BOOTY",
            "NEXT_BATTLE",
            "NEXT_BOOST"
        ],
        "locations": [
            "KARLIN",
            "HOLESOVICE",
            "VINOHRADY",
            "SMICHOV"
        ],
        "image": imageTerezaS
    },
    {
        "name": "Veronika B.",
        "instagram": "veronika.be",
        "cleanName": "Veronika Benesova",
        "gender": "FEMALE",
        "concepts": [
            "PERSONAL_TRAINER",
            "LES_MILLS"
        ],
        "locations": [
            "KARLIN"
        ],
        "image": imageVeronikaB
    },
    {
        "name": "Veronika H.",
        "instagram": "fitveronika",
        "cleanName": "Veronika Huna",
        "gender": "FEMALE",
        "concepts": [
            "PERSONAL_TRAINER"
        ],
        "locations": [
            "KARLIN",
            "HOLESOVICE",
            "VINOHRADY",
            "SMICHOV"
        ],
        "image": imageVeronikaH
    },
    {
        "name": "Viktorie Ch.",
        "instagram": "chovancova_viktoria",
        "cleanName": "Viktorie Chovancova",
        "gender": "FEMALE",
        "concepts": [
            "PERSONAL_TRAINER"
        ],
        "locations": [
            "KARLIN",
            "HOLESOVICE",
            "SMICHOV"
        ],
        "image": imageViktorieCh
    },
    {
        "name": "Zbyněk V.",
        "instagram": "zbynekvlcek",
        "cleanName": "Zbynek Vlcek",
        "gender": "MALE",
        "concepts": [
            "PERSONAL_TRAINER"
        ],
        "locations": [
            "KARLIN",
            "HOLESOVICE",
            "SMICHOV",
            "VINOHRADY"
        ],
        "image": imageZbynekV
    },

    // ###########
    // INSTRUCTORS
    // ###########
    {
        "name": "Andrea H.",
        "instagram": "andreahlavickova",
        "cleanName": "Andrea Hlavickova",
        "gender": "FEMALE",
        "concepts": [],
        "locations": [],
        "image": imageAndreaH
    },
    {
        "name": "Andy K.",
        "instagram": "andykinska",
        "cleanName": "Andrea Kinska",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_BURN",
            "NEXT_BOOST",
        ],
        "locations": [],
        "image": imageAndreaK
    },
    {
        "name": "Barbora P.",
        "instagram": "barborapoulova",
        "cleanName": "Barbora Poulova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_YOGA",
        ],
        "locations": [
            "HOLESOVICE"
        ],
        "image": imageBarboraP
    },
    {
        "name": "Barbora S.",
        "instagram": "barbora.szarkova",
        "cleanName": "Barbora Szarkova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_BURN",
            "NEXT_BOOST",
        ],
        "locations": [],
        "image": imageBarboraS
    },
    {
        "name": "Barbora M.",
        "instagram": "barca.millerova",
        "cleanName": "Barbora Millerova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_YOGA"
        ],
        "locations": [],
        "image": imageBarboraM
    },
    {
        "name": "Becca H.",
        "instagram": "bmoorenasty",
        "cleanName": "Becca Horak",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_YOGA"
        ],
        "locations": [],
        "image": imageBeccaH
    },
    {
        "name": "Denisa Ž.",
        "instagram": "denik_sunshine",
        "cleanName": "Denisa Zidekova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_YOGA",
        ],
        "locations": [],
        "image": imageDenisaZ
    },
    {
        "name": "Eva D.",
        "instagram": "evcadob",
        "cleanName": "Eva Dobesova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_BATTLE",
            "LES_MILLS"
        ],
        "locations": [],
        "image": imageEvaD
    },
    {
        "name": "Eva K.",
        "instagram": "ekarska",
        "cleanName": "Eva Karska",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_YOGA"
        ],
        "locations": [],
        "image": imageEvaK
    },
    {
        "name": "Jakub F.",
        "instagram": "yaboyjimms",
        "cleanName": "Jakub Filipec",
        "gender": "MALE",
        "concepts": [
            "NEXT_BATTLE"
        ],
        "locations": [],
        "image": imageJakubF
    },
    {
        "name": "Jirka Z.",
        "instagram": "jirka_zikmund",
        "cleanName": "Jiri Zikmund",
        "gender": "MALE",
        "concepts": [
            "LES_MILLS"
        ],
        "locations": [],
        "image": imageJiriZ
    },
    {
        "name": "Kat D.",
        "instagram": "kat_dymakova_yoga",
        "cleanName": "Kat Dymakova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_YOGA"
        ],
        "locations": [],
        "image": imageKatD
    },
    {
        "name": "Kathi S.",
        "instagram": "kathi7hands",
        "cleanName": "Kathi Siebenhandl",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_YOGA",
        ],
        "locations": [],
        "image": imageKathiS
    },
    {
        "name": "Kristyna K.",
        "instagram": "kristy_kajgrova",
        "cleanName": "Kristyna Kajgrova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_YOGA",
        ],
        "locations": [],
        "image": imageKristynaK
    },
    {
        "name": "Lenka D.",
        "instagram": "leni_dew",
        "cleanName": "Lenka Dewachter",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_YOGA",
        ],
        "locations": [],
        "image": imageLenkaD
    },
    {
        "name": "Lukáš B.",
        "instagram": "lukasberanek",
        "cleanName": "Lukas Beranek",
        "gender": "MALE",
        "concepts": [
            "LES_MILLS",
        ],
        "locations": [],
        "image": imageLukasB
    },
    {
        "name": "Marek R.",
        "instagram": "marek.rakus",
        "cleanName": "Marek Rakus",
        "gender": "MALE",
        "concepts": [
            "NEXT_BATTLE",
        ],
        "locations": [],
        "image": imageMarekR
    },
    {
        "name": "Martina D.",
        "instagram": "marta_deverova",
        "cleanName": "Martina Deverova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_BOOTY",
            "LES_MILLS",
        ],
        "locations": [],
        "image": imageMartinaDeverova
    },
    {
        "name": "Martina K.",
        "instagram": "_mkosikova",
        "cleanName": "Martina Kosikova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_BOOTY",
            "NEXT_BOOST"
        ],
        "locations": [],
        "image": imageMartinaK
    },
    {
        "name": "Martina V.",
        "instagram": "marti.yogajourney",
        "cleanName": "Martina Vaic",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_YOGA"
        ],
        "locations": [],
        "image": imageMartinaV
    },
    {
        "name": "Michaela F.",
        "instagram": "michaellafrancova",
        "cleanName": "Michaela Francova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_BOOTY"
        ],
        "locations": [],
        "image": imageMichaelaF
    },
    {
        "name": "Michaela M.",
        "instagram": "miskamacko",
        "cleanName": "Michaela Mackovicova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_YOGA",
        ],
        "locations": [],
        "image": imageMichaelaM
    },
    {
        "name": "Monika Z.",
        "instagram": "monikazemankova_",
        "cleanName": "Monika Zemankova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_BURN",
            "LES_MILLS",
        ],
        "locations": [],
        "image": imageMonikaZ
    },
    {
        "name": "Natálie H.",
        "instagram": "nataliehajna",
        "cleanName": "Natalie Hajna",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_BURN",
            "LES_MILLS"
        ],
        "locations": [],
        "image": imageNatalieH
    },
    {
        "name": "Nikola M.",
        "instagram": "nikol.mandik",
        "cleanName": "Nikola Mandikova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_BATTLE"
        ],
        "locations": [],
        "image": imageNikolaM
    },
    {
        "name": "Nikola Š.",
        "instagram": "n_simunkova",
        "cleanName": "Nikola Simunkova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_BURN",
            "NEXT_BOOTY"
        ],
        "locations": [],
        "image": imageNikolaS
    },
    {
        "name": "Ondřej B.",
        "instagram": "onicek83",
        "cleanName": "Ondrej Becan",
        "gender": "MALE",
        "concepts": [
            "NEXT_BURN",
            "NEXT_BATTLE"
        ],
        "locations": [],
        "image": imageOndrejB
    },
    {
        "name": "Pavlina B.",
        "instagram": "baudysovap",
        "cleanName": "Pavlina Baudysova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_BURN",
            "NEXT_BOOST",
            "NEXT_YOGA",
            "LES_MILLS"
        ],
        "locations": [],
        "image": imagePavlinaB
    },
    {
        "name": "Petr M.",
        "instagram": "petmis91",
        "cleanName": "Petr Miskovsky",
        "gender": "MALE",
        "concepts": [
            "NEXT_YOGA",
        ],
        "locations": [],
        "image": imagePetrM
    },
    {
        "name": "Petr R.",
        "instagram": "petrrada97",
        "cleanName": "Petr Rada",
        "gender": "MALE",
        "concepts": [
            "LES_MILLS",
        ],
        "locations": [],
        "image": imagePetrR
    },
    {
        "name": "Petra K.",
        "instagram": "petrakacirkova",
        "cleanName": "Petra Kacirkova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_BURN",
            "NEXT_BATTLE"
        ],
        "locations": [],
        "image": imagePetraK
    },
    {
        "name": "Piper P.",
        "instagram": "piperloriparker",
        "cleanName": "Piper Parker",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_YOGA",
        ],
        "locations": [],
        "image": imagePiperP
    },
    {
        "name": "Polly D.",
        "instagram": "p.onchiq",
        "cleanName": "Polly Dvorkin",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_BATTLE",
            "LES_MILLS",
        ],
        "locations": [],
        "image": imagePollyD
    },
    {
        "name": "Romana Z.",
        "instagram": "romana.zikmundova",
        "cleanName": "Romana Zikmundova",
        "gender": "FEMALE",
        "concepts": [
            "LES_MILLS",
        ],
        "locations": [],
        "image": imageRomanaZ
    },
    {
        "name": "Sabina A.",
        "instagram": "sabina_zova",
        "cleanName": "Sabina Azizova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_YOGA",
        ],
        "locations": [],
        "image": imageSabinaA
    },
    {
        "name": "Sarka S.",
        "instagram": "coachsarka",
        "cleanName": "Sarka Sachl",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_YOGA",
        ],
        "locations": [],
        "image": imageSarkaS
    },
    {
        "name": "Tatiana H.",
        "instagram": "hatiannaa",
        "cleanName": "Tatiana Hatadamova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_DANCE",
        ],
        "locations": [],
        "image": imageTatianaH
    },
    {
        "name": "Tereza D.",
        "instagram": "tess_dobias",
        "cleanName": "Tereza Dobiasova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_BURN",
            "NEXT_BOOST",
        ],
        "locations": [
            "HOLESOVICE"
        ],
        "image": imageTerezaD
    },
    {
        "name": "Tereza E.",
        "instagram": "terezaeliasovaa",
        "cleanName": "Tereza Eliasova",
        "gender": "FEMALE",
        "concepts": [
            "LES_MILLS",
        ],
        "locations": [],
        "image": imageTerezaE
    },
    {
        "name": "Tomáš S.",
        "instagram": "tomash_strnad",
        "cleanName": "Tomas Strnad",
        "gender": "MALE",
        "concepts": [
            "NEXT_YOGA"
        ],
        "locations": [],
        "image": imageTomasS
    },
    {
        "name": "Viktorie F.",
        "instagram": "viktoriefilipi",
        "cleanName": "Viktorie Filipi",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_BOOTY",
        ],
        "locations": [],
        "image": imageViktorieF
    },
    {
        "name": "Zofie P.",
        "instagram": "zofiepickova",
        "cleanName": "Zofie Pickova",
        "gender": "FEMALE",
        "concepts": [
            "NEXT_YOGA",
        ],
        "locations": [],
        "image": imageZofieP
    },
];

export const getTrainerVideoUrl = (cleanName) => {
    cleanName = cleanName.toLowerCase();
    const name = cleanName.split(' ');
    return `/videos/trainers/${name[0]}_${name[1]}.mp4`;
}

export const trainersConcepts = {
    "PERSONAL_TRAINER": "Personal Trainer",
    "LES_MILLS": "Les Mills",
    "NEXT_BATTLE": "Next.Battle",
    "NEXT_BOOTY": "Next.Booty",
    "NEXT_BURN": "Next.Burn",
    "NEXT_HOTYOGA": "Next.HotYoga",
    "NEXT_YOGA": "Next.Yoga",
    "NEXT_BOOST": "Next.Boost",
};


export const getConceptFriendlyName = (concept) => {
    return trainersConcepts[concept] || concept;
}